export enum PropertyStatus {
  AC = "Acquired",
  PS = "Partially Sold",
  SO = "Sold"
}

export const mapPropertyStatus = (status: string): PropertyStatus => {
  const statusMapping: { [key: string]: PropertyStatus } = {
    AC: PropertyStatus.AC,
    PS: PropertyStatus.PS,
    SO: PropertyStatus.SO,
  };

  return statusMapping[status] || undefined;
};
